import { useQuery } from 'react-query';

import { dreamsMetadata } from '@/environment';

export interface IDreamsMetadata {
    prompts: {
        prompt: string;
        img: string;
    }[];
    prefixes: string[];
    suffixes: string[];
}

async function getMetadata() {
    const request = await fetch(dreamsMetadata);
    return (await request.json()) as IDreamsMetadata;
}

const DREAMS_METADATA_KEY = 'dreamsMetadata';

export default function (onSuccess?: (data: IDreamsMetadata) => void) {
    return useQuery(DREAMS_METADATA_KEY, getMetadata, { onSuccess });
}
